import React, { useState } from 'react';
import { Modal } from 'junto-ui';
import { useStore } from '@store';
import { observer } from 'mobx-react';
import AccountServices from '@ncl/modules/account/services/AccountServices';
import {
  Wrapper,
  Title,
  ComplementaryText,
  CheckboxLabel,
  ConfirmButton,
  Checkbox,
} from './JudicialNoRefundTermModalStyles';

const JudicialNoRefundTermModal = () => {
  const sharedStore = useStore('sharedStore');
  const { currentJudicialNoRefundTerms } = sharedStore;
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);

  const handleCheckboxCheck = () => {
    setAcceptedTerms(!acceptedTerms);
  };

  const handleConfirm = async () => {
    setButtonLoading(true);
    const { id } = currentJudicialNoRefundTerms;
    await AccountServices.acceptRequiredTerms(id);
    setButtonLoading(false);
    sharedStore.setCurrentJudicialNoRefundTerms(undefined);
  };

  return (
    <Modal
      isOpen={!!currentJudicialNoRefundTerms}
      mobileFullScreen
      hideCloseButton
      width="640px"
      height="486px"
    >
      <Wrapper>
        <Title>Antes de seguir, temos um recado para você!</Title>
        <ComplementaryText>
          Tivemos recentemente uma alteração importante referente a restituição de valores na
          modalidade de seguro <strong>judicial para depósito recursal</strong>. Para continuar é
          importante que você saiba dessa alteração.
        </ComplementaryText>
        <Checkbox
          name="judicial-no-refund"
          id="judicial-no-refund-term"
          data-testid="judicial-no-refund-term"
          label={
            <CheckboxLabel>
              Declaro estar ciente e de acordo que{' '}
              <strong>
                (i) não haverá, em qualquer hipótese, a devolução de prêmio para apólice(s) e/ou
                endosso(s) emitido(s) na modalidade judicial para depósito recursal
              </strong>
              , ainda que anteriormente à data desta declaração; e (ii) a presente declaração altera
              expressa e pontualmente previsão em sentido contrário, caso haja, estipulada no
              Contrato de Contragarantia celebrado por este Tomador e a Junto Seguros S.A., bem como
              na Cláusula 15ª das Condições Gerais das apólices atualmente em vigor ou que
              porventura sejam emitidas ao Tomador, quando aplicável, importando em renúncia à
              restituição do prêmio para as modalidades de seguro ora descrita.
            </CheckboxLabel>
          }
          checked={acceptedTerms}
          onChange={handleCheckboxCheck}
        />
        <ConfirmButton
          variant="primary"
          disabled={!acceptedTerms}
          data-testid="judicial-no-refund-term-confirm"
          onClick={handleConfirm}
          isLoading={buttonLoading}
        >
          Aceitar e continuar
        </ConfirmButton>
      </Wrapper>
    </Modal>
  );
};

export default observer(JudicialNoRefundTermModal);
